import React, { useState, useContext } from "react";
import { TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
// import LockIcon from "@material-ui/icons/Lock";
// import LockOpenIcon from "@material-ui/icons/LockOpen";
import LayoutContext, { ILayoutContext } from "../../contexts/layout/LayoutContext";
import { DynamicFormFieldProps } from "../DynamicForm";
// import { UILightTooltip } from "../../ui/UIComponents";
import { FormLabel } from ".";
import { UIStyledTooltip } from "../../components/ui/UIComponents";
import { DynamicFormField } from "../../laco-common/base/form-validation/dynamic";
import { FormFieldType } from "../../laco-common";
import QuillEditor from "../../components/quill";

export const EditorInput: React.FC<DynamicFormFieldProps> = (props: DynamicFormFieldProps) => {
	const field: DynamicFormField = props.field;
	const { index, onChange, onBlur, processing, getHelperText, omitLabel, autoFocusFieldKey: focusFieldKey } = props; // variant

	return (
		<>
			<div className="w-100 position-relative" id="editor-input">
				{!omitLabel && <FormLabel field={field} />}
				<QuillEditor
					text={field.value}
					placeholder={field.placeholder || "Start typing here..."}
					onChange={(html: string) => {
						// validate scripts
						// html.replace(/</g, "&lt;").replace(/>/g, "&gt;");
						console.log("Editor content changed");
						onChange(html);
					}}
				/>
			</div>
		</>
	);
};

export default EditorInput;
